module.exports = __webpack_public_path__ + "img/r0sf.c747334d.png";